import React from 'react';
import { Button, Form, Header, Input, Segment } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { toast, ToastContainer } from 'react-toastify';
import { DateTimePicker } from 'react-widgets';
import request from '../../util/request';
import { fetchSemesters } from '../../StudentService/StudentServiceInputGrades/InputGradesFilterStudents';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


const object = {};
const fetchGradingMethods = () => axios.get('/grading-methods');
const fetchExamTypes = () => axios.get('/graded-activity-types');
const fetchAcademicYears = () => axios.get('/academic-years/current-and-previous/');
const fetchExamTerms = () => axios.get(`/exams/terms/${localStorage.getItem('orgUnitId')}`);


export default class CreateExam extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            examTerms: [],
            examTerm: '',
            academicYears: [],
            academicYear: '',
            courses: [],
            gradingMethods: [],
            gradingMethodId: null,
            examTypes: [],
            examType: null,
            courseStaff: [],
            staffArray: [],

            disabledButton: false
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.addExam = this.addExam.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.resetForm = this.resetForm.bind(this);
    }

    componentDidMount() {
        request.fetchOrgUnits()
            .then(orgUnits => this.setState({ orgUnits }));

        axios.all([fetchGradingMethods(), fetchExamTypes(), fetchAcademicYears(), fetchSemesters()])
            .then(axios.spread((gradingMethodRes, examTypeRes, yearsRes, semRes) => {
                const gradingMethods = gradingMethodRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el._key
                }));
                const examTypes = examTypeRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el.id
                }));

                const academicYears = yearsRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                })).reverse();

                const semesters = semRes.data.filter(e => e.name.name !== 'ostalo').map(el => ({
                    key: el.name._key, value: el.name._key, text: el.name.name
                }));

                this.setState({
                    academicYears,
                    examTypes,
                    gradingMethods,
                    gradingMethodId: gradingMethods.find(e => e.key === 'written exam').id,
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch data...');
            });
    }

    resetForm() {
        this.setState({
            examTerm: '',
            academicYear: '',
            courses: [],
            gradingMethodId: null,
            examType: null,
            courseStaff: [],
            staffArray: [],
            comment: null,
            date: null,
            disabledButton: false
        });
    }

    addExam(examTypeId, gradingMethodId, date, staffArray, classroom, groupIds, comment) {
        console.log('kreiraj ispit');
        if (!examTypeId || !gradingMethodId || !date) {
            toast('Niste unijeli sva obavezna polja!');
            if (!examTypeId) {
                this.setState({ examTypeErr: true });
            } else {
                this.setState({ examTypeErr: false });
            }
            if (!gradingMethodId) {
                this.setState({ gradingMethodIdErr: true });
            } else {
                this.setState({ gradingMethodIdErr: false });
            }
            if (!date) {
                this.setState({ dateErr: true });
            } else {
                this.setState({ dateErr: false });
            }
        } else {
            console.log('elseee');
            const {
                examTypes, gradingMethods
            } = this.state;

            const courseImplementationId = this.state.course;
            let examDate = moment(date).format();

            const gradedActivityRegistrationDate = { id: this.state.examTerm - 1 };

            let staff = [];
            if (staffArray.length) {
                staff = staffArray.map(el => ({ id: el }));
            }

            let gradedActivityTypeKey = examTypes.find(el => el.id === examTypeId)._key;

            let gradingMethodKey = gradingMethods.find(el => el.id === gradingMethodId)._key;


            let docExam = {
                gradedActivityRegistrationDate,
                courseImplementationId,
                gradedActivityTypeKey,
                gradingMethodKey,
                examDate,
                staff,
                classroom
            };

            if (comment) {
                docExam = { ...docExam, comment };
            }


            axios.post('exams/false', { ...docExam })
                .then(res => {
                    if (groupIds) {
                        let groups = [];
                        groups.push(groupIds);
                        axios.post(`exams/add-group/${res.data.gradedActivityId}`, [...groups])
                            .then(() => {
                                toast('Uspješno ste kreirali ispit i dodali grupu na ispit.');
                                this.resetForm();
                            }).catch(err => {
                                toast('Došlo je do greške. Dodavanje grupe na ispit nije uspjelo.');
                            });
                    } else {
                        toast('Uspješno ste kreirali ispit.');
                        this.resetForm();
                    }
                })
                .catch(err => {
                    toast('Došlo je do greške. Kreiranje ispita nije izvršeno.');
                });
        }
    }


    handleChange(name, date) {
        if (moment(date).format('D.M.YYYY.') !== moment(this.state.startDate).format('D.M.YYYY.') && moment(date).format('D.M.YYYY.') !== moment(this.state.endDate).format('D.M.YYYY.')) {
            if (date < this.props.startDate || date > this.props.endDate) {
                toast('Datum ispita mora biti unutar vremenskog intervala odabranog ispitnog roka!');
                return;
            }
        }

        this.setState({
            [name]: date
        });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });

        if (name === 'orgUnit') {
            localStorage.setItem('orgUnitId', value);

            axios.all([fetchExamTerms()])
                .then(axios.spread((res) => {
                    this.setState({
                        examTerms: res.data.map(el => ({
                            ...el,
                            text: el.name + ' (' + moment(el.startDate).format('D. M. YYYY.') + ' - ' + moment(el.endDate).format('D. M. YYYY.') + ')',
                            value: el.id + 1,
                            key: el.id + 1
                        }))
                    });
                }))
                .catch(err => {
                    console.log('Failed to fetch exam terms...');
                });
        }

        if (name === 'academicYear') {
            localStorage.setItem('academicYear', value);
            let academicYear = {};
            let academicYearId = localStorage.getItem('academicYear');
            academicYear = { ...academicYear, academicYearId };
            axios.get(`course/filter-implementations/${localStorage.getItem('orgUnitId')}`, { params: academicYear })
                .then(res => {
                    this.setState({
                        courses: res.data.map(el => ({
                            text: (el.code) ? el.courseBasic.name + ' | ' + el.code + ' | ' + el.semesters[0].name.name : el.courseBasic.name + ' | ' + el.semesters[0].name.name,
                            value: el.id,
                            key: el.id,
                            description: el.comment ? el.comment : ''
                        }))
                    });
                })
                .catch(err => {
                    console.log('Failed to fetch course implementations.');
                });
        }

        if (name === 'course') {
            axios.get(`/course/implementation/staff/${value}`)
                .then(res => {
                    this.setState({
                        courseStaff: res.data.map(el => ({
                            ...el,
                            text: el.employee.person.firstName + ' ' + el.employee.person.lastName + ' - ' + el.courseRoleType.name,
                            value: el.id,
                            key: el.id
                        }))
                    });
                })
                .catch(err => {
                    console.log('Failed to fetch course staff.');
                });

            axios.get('/group-types')
                .then(res => {
                    const groupType = res.data.find(e => e._key === 'exam').id;
                    let obj = {};
                    axios.post(`course/groups/${value}/${groupType}`, { ...obj })
                        .then(result => {
                            let groups = result.data.filter(e => !e.archived).map(el => ({
                                text: el.name, value: el.id, key: el.id
                            }));
                            this.setState({
                                groups,
                                haveGroup: groups.length !== 0
                            });
                        })
                        .catch(err => {
                            console.log('Failed to fetch groups');
                        });
                })
                .catch(err => {
                    console.log('Failed to fetch group types');
                });
        }
    }


    render() {
        return (
            <div>
                <Header as="h1"> Kreiranje ispita </Header>
                <Segment.Group raised>
                    <Segment raised>
                        <Header as="h3">
                            Kreiranje ispita
                        </Header>
                    </Segment>
                    <Segment clearing>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field required>
                                    <label>Organizaciona jedinica</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite organizacionu jedinicu"
                                        value={this.state.orgUnit}
                                        onChange={this.handleInputChange}
                                        name="orgUnit"
                                        options={this.state.orgUnits}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field required>
                                    <label>Akademska godina</label>
                                    <Form.Dropdown
                                        placeholder="Odaberite akademsku godinu"
                                        value={this.state.academicYear}
                                        onChange={this.handleInputChange}
                                        name="academicYear"
                                        options={this.state.academicYears}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Form>
                        <Form noValidate>
                            <Form.Group widths="equal">
                                <Form.Field required error={this.state.examTermErr} disabled={!this.state.academicYear}>
                                    <label>Predmet</label>
                                    <Form.Dropdown
                                        clearable
                                        selection
                                        placeholder="Odaberite predmet"
                                        value={this.state.course}
                                        onChange={this.handleInputChange}
                                        name="course"
                                        options={this.state.courses}
                                        search
                                        fluid
                                    />
                                </Form.Field>
                                <Form.Field required error={this.state.examTermErr} disabled={!this.state.orgUnit}>
                                    <label>Ispitni rok</label>
                                    <Form.Dropdown
                                        selection
                                        placeholder="Odaberite ispitni rok"
                                        value={this.state.examTerm}
                                        onChange={this.handleInputChange}
                                        name="examTerm"
                                        options={this.state.examTerms}
                                        search
                                        fluid
                                    />
                                </Form.Field>
                            </Form.Group>

                            <Form.Group widths="equal" >
                                <Form.Field required error={this.state.dateErr} >
                                    <label>Datum i vrijeme ispita</label>
                                    <DateTimePicker
                                        defaultValue={new Date()}
                                        format="D. M. YYYY. - HH:mm"
                                        timeFormat="HH:mm"
                                        onChange={this.handleChange.bind(null, 'date')}
                                        value={this.state.date}
                                        placeholder="Unesite datum u formatu D. M. GGGG."
                                    />
                                </Form.Field>

                                <Form.Field required error={this.state.examTypeErr}>
                                    <label>Tip ispita</label>
                                    <Form.Dropdown
                                        clearable
                                        selection
                                        placeholder="Odaberite tip ispita"
                                        value={this.state.examType}
                                        onChange={this.handleInputChange}
                                        name="examType"
                                        options={this.state.examTypes.filter(el => el.id === 2 || el.id === 3)}
                                        search
                                        fluid
                                    />
                                </Form.Field>
                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field required error={this.state.gradingMethodIdErr} >
                                    <label>Način ispitivanja</label>
                                    <Form.Dropdown
                                        clearable
                                        selection
                                        placeholder="Odaberite način ispitivanja"
                                        value={this.state.gradingMethodId}
                                        onChange={this.handleInputChange}
                                        name="gradingMethodId"
                                        options={this.state.gradingMethods}
                                        search
                                        fluid
                                    />
                                </Form.Field>

                                <Form.Field>
                                    <label>Ispitna grupa</label>
                                    <Form.Dropdown
                                        clearable
                                        selection
                                        placeholder="Odaberite grupu"
                                        value={this.state.groupIds}
                                        onChange={this.handleInputChange}
                                        name="groupIds"
                                        options={this.state.groups}
                                        search
                                        fluid
                                    />

                                </Form.Field>
                            </Form.Group>

                            <Form.Group widths="equal">

                                <Form.Field required={localStorage.getItem('thirdCycle') === 'false' && localStorage.getItem('specialist') === 'false'} error={this.state.staffArrayErr}>
                                    <label>Osoblje zaduženo za ispit</label>
                                    <Form.Dropdown
                                        clearable
                                        selection
                                        multiple
                                        placeholder="Odaberite osoblje"
                                        value={this.state.staffArray}
                                        onChange={this.handleInputChange}
                                        name="staffArray"
                                        options={!this.state.haveGroup ? this.state.courseStaff.filter(el => (el.archived !== true && (el.leadStaff === true || el.courseRoleType.name === 'asistent'))) : this.state.courseStaff.filter(el => el.archived !== true)}
                                        search
                                        fluid
                                    />
                                </Form.Field>

                                <Form.Field
                                    label="Prostorija"
                                    control={Input}
                                    name="classroom"
                                    value={this.state.classroom}
                                    onChange={this.handleInputChange}
                                    placeholder="Unesite prostoriju"
                                />
                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label> Napomena</label>
                                    <Form.TextArea
                                        placeholder="Unesite napomenu"
                                        rows={2}
                                        name="comment"
                                        value={this.state.comment}
                                        onChange={this.handleInputChange}
                                    />
                                </Form.Field>
                                <Form.Field />
                            </Form.Group>


                            <Button
                                floated="right"
                                basic="true"
                                color="blue"
                                onClick={() => {
                                    this.resetForm();
                                }}
                            >
                                Odustani
                            </Button>

                            <Button
                                floated="right"
                                color="blue"
                                disabled={this.state.disabledButton}
                                onClick={
                                    () => {
                                        this.setState({ disabledButton: true }, () => {
                                            this.addExam(
                                                this.state.examType,
                                                this.state.gradingMethodId,
                                                this.state.date,
                                                this.state.staffArray,
                                                this.state.classroom,
                                                this.state.groupIds,
                                                this.state.comment
                                            );
                                        });
                                    }
                                }
                            >
                                Kreiraj ispit
                            </Button>

                        </Form>

                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/Exams/CreateExam.js